import { schema } from 'normalizr';

export const customerSchema = new schema.Entity('customers');
export const partnerSchema = new schema.Entity('partners');

export const arrayOfCustomers = [ customerSchema ];
export const arrayOfPartners = [ partnerSchema ];
